import React, { useState } from 'react';
import { Box, HStack, Text, Button, IconButton } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { motion, AnimatePresence } from 'framer-motion';

const MotionBox = motion(Box);
const DISMISSED_KEY = 'lumene_install_dismissed';

export function InstallBanner({ canInstall, onInstall }) {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISSED_KEY) === '1'
  );

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, '1');
    setDismissed(true);
  };

  return (
    <AnimatePresence>
      {canInstall && !dismissed && (
        <MotionBox
          position="fixed"
          bottom={0}
          left={0}
          right={0}
          zIndex={1000}
          bg="lumene.night"
          borderTop="1px solid"
          borderColor="lumene.copper"
          px={4}
          py={3}
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          role="banner"
          aria-label="Installer l'application"
        >
          <HStack justify="space-between" align="center" spacing={3}>
            {/* Icon + text */}
            <HStack spacing={3} flex={1} minW={0}>
              {/* Small favicon replica */}
              <Box
                w="36px" h="36px" borderRadius="sm" bg="lumene.night"
                border="1px solid" borderColor="lumene.copper"
                flexShrink={0}
                display="flex" alignItems="center" justifyContent="center"
                fontSize="16px" color="lumene.off"
                fontFamily="'Atkinson Hyperlegible', sans-serif"
              >
                ê
              </Box>
              <Box minW={0}>
                <Text fontSize="sm" fontWeight="bold" color="lumene.off" noOfLines={1}>
                  Lumène
                </Text>
                <Text fontSize="xs" color="lumene.off" opacity={0.65} noOfLines={1}>
                  Ajouter à l'écran d'accueil
                </Text>
              </Box>
            </HStack>
            {/* Actions */}
            <HStack spacing={2} flexShrink={0}>
              <Button
                size="sm"
                bg="lumene.copper"
                color="lumene.night"
                _hover={{ bg: '#9A7A4A' }}
                _active={{ bg: '#8A6A3A' }}
                borderRadius="md"
                fontWeight="bold"
                onClick={onInstall}
                aria-label="Installer l'application Lumène"
              >
                Installer
              </Button>
              <IconButton
                icon={<CloseIcon boxSize="10px" />}
                size="sm"
                variant="ghost"
                color="lumene.off"
                opacity={0.6}
                _hover={{ opacity: 1, bg: 'rgba(248,244,236,0.1)' }}
                borderRadius="md"
                onClick={handleDismiss}
                aria-label="Fermer"
              />
            </HStack>
          </HStack>
        </MotionBox>
      )}
    </AnimatePresence>
  );
}
